import {rupiah} from 'utils/formatter'

class Subtotal extends React.Component {
  render () {
    let {subtotal} = this.props
    return <div>
      <div className='pull-left'>Subtotal</div>
      <div className='pull-right'>{this._formatSubtotal(subtotal)}</div>
      <div className='clearfix' />
    </div>
  }

  _formatSubtotal = (subtotal) => {
    if (subtotal > 0) {
      return rupiah(subtotal)
    } else {
      return `(${rupiah(-1 * subtotal)})`
    }
  }
}

Subtotal.propTypes = {
  subtotal: React.PropTypes.number
}

export default Subtotal



// WEBPACK FOOTER //
// ./app/components/receipt/commons/CountingBox/Subtotal/Subtotal.js